import mixins from 'synergycms_core/src/less/mixins';

export default {
  relativeContainer: {},
  backButton: {},
  hotelCalendar: {},
  selectRoom: {},
  hotelLink: {},
  hotelsLink: {},
  currenciesButton: {},
  multiHotelSearchOptions: {
    backgroundColor: '#fff',
    fontFamily: data => data.fontFamily1,
    position: 'relative',
  },
  mapOptions: {
    '& $multiHotelSearchOptionsHeader': {
      display: 'none'
    },
    '& $searchOptionsContainer': {
      '@media (min-width: 1200px),print': {
        width: '100%'
      }
    }
  },
  relativeFilter: {
    borderBottom: '1px solid #d8d8d8',
    '@media (min-width: 1001px),print': {
      position: 'relative',
      paddingBottom: '1px',   
      '&:after': {
        content: "''",
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '0',
      }
    },
    '@media (min-width: 1200px),print': {
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  monoHotelSearchOptionsContent: {
    height: '40px',
    display: 'table',
    width: '100%',
    '@media (max-width: 800px)': {
      //borderBottom: '1px solid #d8d8d8'
    }
  },
  backBtnContainer: {
    maxWidth: '1170px',
    margin: '0 auto'
  },
  searchOptionsContainer: {
    display: 'flex',
    '@media (min-width: 1001px),print': {
      minWidth: '400px'
    }
    
  },
  multiHotelSearchOptionsHeader: {
    padding: '10px 10px 8px',
    font: data => '13px ' + data.fontFamily1,
    borderBottom: '1px solid #d8d8d8',
    display: 'block',
    '@media (min-width: 1001px),print': {
      padding: '16px 10px 16px 30px'
    },
    '@media (min-width: 1200px),print': {
      borderBottom: 0,
      '&:lang(ar)': {
        display: 'flex',
        gap: '5px',
      },
    }
  },
  searchOptionsButton: {
    width: '100%',
    textAlign: 'left',
    borderLeft: '1px solid #d8d8d8',
    padding: '0 25px 0 27px',
    position: 'relative',
    fontSize: '13px',
    height: '40px',
    '@media (min-width: 1001px),print': {
      height: '50px'
    },
    '&:lang(ar)': {
      textAlign: "right",
      paddingLeft: "25px",
      paddingRight: "27px",
      borderLeft: "none",
      //borderRight: "1px solid #d8d8d8"
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '20%',
      right: '20%',
      background: 'transparent',
      bottom: '0',
      height: '3px',
      ...mixins.transition()
    },
    '&:hover:after': {
      left: 0,
      right: 0,
      backgroundColor: data => data.mainColor
    }
  },
  filterContainer: {
    width: '33.333%',
    '&$relativeContainer': {
      position: 'relative',
      right: '1px'
    }
  },
  svgIcon: {
    position: 'absolute',
    top: '50%',
    left: '7px',
    width: '14px',
    height: '14px',
    fill: data => data.mainColor,
    marginTop: '-7px',
    '&:lang(ar)': {
      left: 'auto',
      right: '7px'
    }
  },
  calendarSvg: {
    width: 20,
    height: 20,
    position: 'absolute',
    left: 17,
    top: '50%',
    marginTop: -10,
    fill: data => data.mainColor,
    '&:lang(ar)': {
      left: 'auto',
      right: '17px'
    }
  },
  monoHotelSearchOptions: {
    background: '#fff',
    width: '100%',
    position: 'relative',
    textAlign: 'center',
    '& $searchOptionsButton': {
      width: '120px',
      height: '100%',
      display: 'table-cell',
      verticalAlign: 'middle',
      padding: '18px 0 18px 15px',
      cursor: 'pointer',
      '&:lang(ar)': {
        paddingRight: '15px',
        paddingLeft: '0'
      }
    },
    '& $backButton': {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: '40px',
      height: '40px',
      //borderRight: '1px solid #d8d8d8',
      //borderLeft: '1px solid #d8d8d8',
      boxSizing:'border-box',
      '@media (min-width: 801px),print': {
        width: '50px',
        height: '50px'
      },
      '&:lang(ru)': {
        '@media (min-width: 801px),print': {
          height: '66px'
        }
      },
      '&:lang(ar)':{
        transform: 'rotate(180deg)',
        '& button':{
          width: '100%',
          height: '100%',
        }
      }
    },
    '& $hotelCalendar': {
      display: 'none',
      '@media (min-width: 801px),print': {
        display: 'table-cell',
        verticalAlign: 'middle',
        width: '210px',
        //borderLeft: '1px solid #d8d8d8',
        '> button': {
          height: '100%',
          width: '100%',
          padding: '0 25px 0 45px',
          font: data => '13px' + data.fontFamily1,
          textAlign: 'left',
          color: data => data.mainColor,
          position: 'relative',
          '& > span': {
            display: 'block',
            '& > span:first-of-type': {
              width: '20px',
              height: '20px',
              position: 'absolute',
              left: '17px',
              top: '50%',
              marginTop: '-10px',
              '&:lang(ar)': {
                right: '17px',
                left: 'auto'
              }
            },
            '& > span:last-of-type': {
              lineHeight: '18px',
              position: 'absolute',
              right: '0',
              marginLeft: '5px',
              left: 'auto',
              '&:lang(ar)': {
                right: "auto",
                marginLeft: "5px",
                marginRight: "5px",
                left: "0"
              }
            }
          },
          '&:after': {
            content: "''",
            position: 'absolute',
            left: '20%',
            right: '20%',
            background: 'transparent',
            bottom: '0',
            height: '3px',
            ...mixins.transition()
          },
          '&:hover:after': {
            left: 0,
            right: 0,
            background: data => data.mainColor
          },
          '&:lang(ar)': {
            paddingRight: "45px",
            paddingLeft: "25px",
            textAlign: "right"
          }
        }
      },
      '&:lang(ar)': {
        '@media (min-width: 801px),print': {
          borderLeft: "none",
          //borderRight: "1px solid #d8d8d8"
        }
      }
    },
    '& $selectRoom': {
      display: 'table-cell',
      verticalAlign: 'middle',
      font: data => 'bold 13px/1.38 ' + data.fontFamily1,
      padding: '2px 5px 2px 15px',
      height: '40px',
      boxSizing:'border-box',
      '@media (min-width: 801px),print': {
        fontSize: '16px',
        textAlign: 'left',
        paddingLeft: '18px',
        height: '50px'
      },
      '&:lang(ar)': {
        paddingRight: '15px',
        paddingLeft: '5px',
        '@media (min-width: 801px)': {
          textAlign: 'right',
          paddingLeft: 0,
          paddingRight: '18px'
        }
      }
    },
    '& $hotelLink': {
      display: 'none',
      '@media (min-width: 801px),print': {
        display: 'table-cell',
        verticalAlign: 'middle',
        width: '120px',
        //borderRight: '1px solid #d8d8d8'
      },
      /*'@media (min-width: 961px),print': {
        width: '140px',
      },*/
      '&:lang(ar)': {
        '@media (min-width: 801px),print': {
          borderRight: 'none'
        }
      },
      '& button': {
        height: '50px',
        textAlign: 'left',
      }
    },
    '& $hotelsLink': {
      //display: 'none',
      //'@media (min-width: 801px),print': {
        display: 'table-cell',
        verticalAlign: 'middle',
        width: '180px',
        //borderRight: '1px solid #d8d8d8',
        '& button > span': {
          display: 'flex',
          textAlign: 'left',
          alignItems: 'center',
          '@media (min-width:961px)': {
            gap: '2px',
          },
          '& div > div > svg': {
            width: '17px'
          }
        },
      //},
      '@media (min-width: 961px),print': {
        width: '195px',
      },
      '&:lang(ar)': {
        '@media (min-width: 801px),print': {
          borderRight: 'none'
        }
      },
      '& button': {
        height: '50px',
      }
    },
    '& $currenciesButton': {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: '70px',
      //borderRight: '1px solid #d8d8d8',
      boxSizing:'border-box',
      '@media (min-width: 961px),print': {
        width: '80px',
      },
      '&:lang(ar)': {
        borderRight: "none",
        //borderLeft: "1px solid #d8d8d8"
      },
      '& $searchOptionsButton': {
        width: '100%',
        height: '40px',
        padding: '0 10px 0 12px',
        position: 'relative',
        font: data => '300 12px ' + data.fontFamily1,
        textAlign: 'left',
        borderLeft: 'none',
        '&:lang(ar)': {
          paddingRight: "20px",
          paddingLeft: "25px",
          textAlign: "right"
        },
        '@media (min-width: 801px),print': {
          height: '50px',
          fontSize: '13px'
        },
        '@media (min-width: 961px),print': {
          padding: '0 20px 0 20px',
        }
      }
    },
    '& $monoHotelSearchOptionsContent': {
      '@media (min-width: 801px),print': {
        maxWidth: '1170px',
        margin: '0 auto',
        height: '50px'
      },
      '&:lang(ar)': {
        direction: 'rtl',
      }
    },
    '@media (min-width: 801px),print': {
      //borderBottom: '1px solid #d8d8d8'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px),print': {
        direction: 'rtl'
      }
    }
  },
  rightBorder: {
    //borderRight: '1px solid #d8d8d8',
    '&:lang(ar)': {
      borderRight: "none",
    }
  },
  searchOptionsButtonIcon: {
    position: 'absolute',
    top: '50%',
    left: '7px',
    width: '14px',
    height: '14px',
    color: data => data.mainColor,
    marginTop: '-7px',
    '&:lang(ar)': {
      left: 'auto',
      right: '7px'
    }
  },
  searchOptionsButtonIconOpen: {
    font: data => '10px/1px ' + data.fontFamily3,
    position: 'absolute',
    right: '19px',
    top: '50%',
    color: data => data.mainColor,
    '&:lang(ar)': {
      left: '14px',
      right: 'auto',
    }
  },
  white: {
    color: '#fff'
  },
  modalStyle: {
    ...mixins.transition(),
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: '0',
    float: 'left',
    background: 'rgba(0, 0, 0, 0)',
    zIndex: '99999',
    display: 'table',
    '&:lang(ar)': {
      float: 'right'
    }
  },
  modalContentStyle: {
    width: '100%',
    height: '70%',
    position: 'absolute',
    background: 'rgba(255, 255, 255, 1)',
    top: '46%',
    left: '0',
    ...mixins.transform('translate(-50%, -50%)'),
    '&:lang(ar)': {
      left: 'auto',
      right: 0
    }
  },
  monoFilter: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #d8d8d8',
    '& $filterContainer': {
      width: '100%',
      '@media (min-width: 1001px),print': {
        height: '100%',
        width: '50%'
      }
    },
    '& $searchOptionsContainer': {
      width: '30%',
      justifyContent: 'flex-end',
      '& $searchOptionsButton': {
        minHeight: '50px',
        '& $svgIcon': {
          top: '25px'
        }
      },
      '@media (min-width: 1001px),print': {
        justifyContent: 'flex-end',
        width: '33.333%'
      }
    },
    '& $multiHotelSearchOptionsHeader': {
      borderBottom: 0
    },
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  calendarWrapper:{},
  AvailDestination:{
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    position: 'relative',
    padding: '0px 12px',
    width: 'auto',
    '@media (min-width:801px)':{
      order: '2',
      padding: 'unset',
    },
    '& $backBtnContainer': {
      margin: '0',
      width: 'fit-content',
      position: 'relative',
      '& $backButton':{
        textAlign:'end',
        padding:'12px 4px 8px 0',
        width:'auto ',
        height:'auto',
        '@media (min-width:801px)':{
          width: '50px',
          height: '50px',
          padding: '0 4px 0 0',
        }
      }
    },
    '& $calendarWrapper':{
      '@media (min-width:801px)':{
        order: '2'
      }
    },
    '& $hotelsLink': {
      width: 'auto',
      paddingLeft: '8px',
      '& button':{
        position: 'relative',
        height: 'auto',
        padding: '16px 0 8px 0',
        '& span':{
          fontWeight: '400',
          '@media (min-width:801px)':{
            fontWeight: '300',
          }
        },
        '&:after': {
          position: 'absolute',
          content: '\'\'',
          width: '35px',
          height: '100%',
          top: '0',
          left: '-33px'
        },
        '@media (min-width:801px)':{
          padding: '0 10px',
          height: '100%'
        }
      },
      '@media (min-width:801px)':{
        order: '1',
        marginRight: 'auto',
        paddingLeft: '0',
        '& button':{
          '&:hover:before': {
            left: '-15px',
          },
        }
      }
    },
    '& $currencieMobile': {
      '&$currenciesButton':{
        top: '46px',
      }  
    },
    '& $hotelLink':{
      '@media (min-width:801px)':{
        order: '3'
      }
    },
    '& $currenciesButton':{
      '@media (min-width:801px)':{
        order: '4'
      }
    }
  },
  notAvailDestination:{
    position: 'absolute',
    height: '47px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& $backBtnContainer':{
      visibility: 'hidden'   
    },
    '@media (min-width:801px)': {
      position: 'unset',
    },
    '&$wiNotDestination':{
      '& $currencieMobile':{
        top: '16px'
      }  
    }
  },
  currencieMobile:{
    '&$currenciesButton':{
      top: '16px',
      right: '12px',
      zIndex: '1',
      position: 'absolute',
      marginLeft: 'auto',
      pointerEvents: 'auto',
      '& $searchOptionsButton':{
        border: '1px solid #d8d8d8',
        height: 'auto',
        borderRadius: '30px',
        padding: '12px 8px',
        '&:after':{
          display: 'none',
        },
        '& $searchOptionsButtonIconOpen':{
          right: '15px',
        },
        "& span:nth-of-type(2)": {
          position: 'relative',
          left: '4px',
        }
      }
    }
  },
  wiNotDestination:{}
};
